import React, { FC } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../models/Common';
import { ReactComponent as CloseBtn } from '../../../../assets/images/bannerApp/Close.svg';
import { ReactComponent as BannerLogo } from '../../../../assets/images/bannerApp/BannerLogo.svg';
import { BasicButton } from '../../buttons/BasicButton/BasicButton';
import { openNewBrowserTab } from '../../../../services/domService';

interface BannerDownloadAppProps {
  hideBanner: () => void;
}

export const BannerDownloadApp: FC<BannerDownloadAppProps> = ({ hideBanner }) => {
  const { t, i18n } = useTranslation();

  const getStoreType = () => {
    if (isAndroid) {
      return 'Google Play';
    }
    if (isIOS) {
      return 'App Store';
    }
    return '';
  };

  const downloadAppLink = () => {
    if (isAndroid) {
      openNewBrowserTab(
        process.env.REACT_APP_MY_BRIZ_ANDROID ? `${process.env.REACT_APP_MY_BRIZ_ANDROID}&hl=${i18n.language}` : '',
      );
    }
    if (isIOS) {
      openNewBrowserTab(
        process.env.REACT_APP_MY_BRIZ_APPLE ? `${process.env.REACT_APP_MY_BRIZ_APPLE}?l=${i18n.language}` : '',
      );
    }
  };

  return (
    <div className="page-header__banner">
      <div className="page-header__banner__logo">
        <BasicButton handleClick={hideBanner} className="close-btn">
          <CloseBtn />
        </BasicButton>
        <BannerLogo />
        <div className="page-header__banner__logo__description">
          <p className="name">{t('bannerApp.myBriz')}</p>
          <p className="cabinet">{t('bannerApp.userCabinet')}</p>
          <p className="cabinet">
            {t('bannerApp.availableAt')} <span>{getStoreType()}</span>
          </p>
        </div>
      </div>
      <div className="page-header__banner__button">
        <CustomMUIButton
          label={t('buttons.download')}
          handleClick={downloadAppLink}
          className={ButtonClassNames.SecondaryOutlinedBanner}
        />
      </div>
    </div>
  );
};
